import { DataTypeProvider } from '@devexpress/dx-react-grid';
import OnDiskFalseIcon from '../../../NRIcons/OnDiskFalseIcon';
import OnDiskTrueIcon from '../../../NRIcons/OnDiskTrueIcon';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/system/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

const OnDiskFormatter = ({ value }) => {
  const theme = useTheme();

  const TooltipContent = () => (
    <Box display="flex" flexDirection="column" p={0.5}>
      <Typography variant="caption" fontWeight={theme.typography.fontWeightBold}>
        On Disk
      </Typography>
      <Typography variant="caption">{value ? 'True' : 'False'}</Typography>
    </Box>
  );

  return (
    <Tooltip placement="top" title={<TooltipContent />}>
      <Box display="flex" alignItems="center" justifyContent="center">
        {value ? (
          <OnDiskTrueIcon color={theme.palette.info.main} width={20} height={20} />
        ) : (
          <OnDiskFalseIcon color={theme.palette.text.disabled} width={20} height={20} />
        )}
      </Box>
    </Tooltip>
  );
};
export const NROnDiskProvider = props => <DataTypeProvider formatterComponent={OnDiskFormatter} {...props} />;
